/**
 * Former route families (design/os-reorganisation-ecrans § 7, lot R4):
 * /operate/* became /run/*, /build/* and /builder/* became /studio/*. The
 * old prefixes redirect for one release, keeping the rest of the path, the
 * query and the hash.
 */
export const LEGACY_ROUTE_PREFIXES: ReadonlyArray<{ from: string; to: string }> = [
  { from: "/operate", to: "/run" },
  { from: "/builder", to: "/studio" },
  { from: "/build", to: "/studio" },
];

export function legacyRouteTarget(
  pathname: string,
  search = "",
  hash = "",
): string | null {
  for (const { from, to } of LEGACY_ROUTE_PREFIXES) {
    if (pathname === from || pathname.startsWith(`${from}/`)) {
      const rest = pathname.slice(from.length);
      const target = rest && rest !== "/" ? `${to}${rest}` : to;
      return `${target}${search}${hash}`;
    }
  }
  return null;
}
